module.exports = __webpack_public_path__ + "static/media/styrialabs2.af4d3d6e.jpg";